import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

/** Empty state — block (mockup `.empty`) or inline (`.emptyline`). */
@Component({
  selector: 'app-empty-state',
  standalone: true,
  styleUrl: './empty-state.component.scss',
  imports: [CommonModule],
  templateUrl: './empty-state.component.html',
  
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateComponent {
  @Input() mode: 'block' | 'line' = 'block';
  @Input() title = '';
  @Input() message = '';
  @Input() actionLabel?: string;

  @Output() action = new EventEmitter<void>();
}
